import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService, ConfirmationService } from 'primeng/api';
import { TipoMonedaService } from '../../../core/services/tipo-moneda.service';
import { TipoMoneda } from '../../../shared/models/system';

@Component({
  selector: 'app-tipo-moneda-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './tipo-moneda-admin.html',
  styleUrls: ['./tipo-moneda-admin.css']
})
export class TipoMonedaAdminComponent implements OnInit {
  list: TipoMoneda[] = [];
  item: Partial<TipoMoneda> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(
    private service: TipoMonedaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getAll().subscribe({
      next: (data) => {
        this.list = data;
        this.cdr.detectChanges();
      }
    });
  }

  openNew() {
    this.item = { isActive: true };
    this.submitted = false;
    this.dialog = true;
  }

  edit(row: TipoMoneda) {
    this.item = { ...row };
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.item.nombreMoneda?.trim() && this.item.simbolo?.trim()) {
      const req = this.item.id
        ? this.service.update(this.item.id, this.item as TipoMoneda)
        : this.service.create(this.item);
      req.subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Tipo moneda guardado' });
          this.load();
          this.dialog = false;
        }
      });
    }
  }

  toggle(row: TipoMoneda) {
    this.confirmationService.confirm({
      message: `¿${row.isActive ? 'Desactivar' : 'Activar'} ${row.nombreMoneda}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.toggle(row.id).subscribe(() => this.load());
      }
    });
  }
}
